import * as React from 'react'
import { Button } from '@/ui'
import { useWrapConfirm } from '@/modules/shared/hooks/useWrapConfirm'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  isReady?: boolean
  isPending?: boolean
  handleSave?: () => void
  handleReset?: () => void
  isDirty?: boolean
  children?: React.ReactNode
  hasValidationError?: boolean
}

export const BottomActionsBar = ({
  isReady,
  isPending,
  handleReset,
  handleSave,
  isDirty = false,
  children,
  hasValidationError = false,
}: Props) => {
  const wrapConfirm = useWrapConfirm()
  const { t } = useLocalize()

  return isReady && (children || handleSave || handleReset) ? (
    <section className="tw-flex tw-justify-center tw-overflow-y-auto">
      <div className="tw-center-grid-content tw-w-full md:tw-m-auto md:tw-w-fit">
        <div className="tw-col-span-12 tw-my-4 tw-flex tw-justify-end tw-gap-2">
          {children}
          {handleReset && (
            <Button
              disabled={!isDirty}
              className="tw-rounded-lg tw-px-4 tw-text-content-secondary"
              variant="secondary"
              size="sm"
              onClick={wrapConfirm(handleReset, {
                message: t('configuration.reset-confirm'),
              })}
              text={t('common.reset')}
              loading={isPending}
            />
          )}
          {handleSave && (
            <Button
              disabled={hasValidationError || !isDirty}
              className="tw-rounded-lg tw-px-4"
              size="sm"
              onClick={wrapConfirm(handleSave, {
                message: t('configuration.save-confirm'),
              })}
              text={t('common.save')}
              loading={isPending}
            />
          )}
        </div>
      </div>
    </section>
  ) : null
}
